/**
 * Resolves API base URL for local dev, including mobile testing via ngrok.
 * When the page is opened over HTTPS (ngrok) but API host points to localhost,
 * requests go through the CRA dev-server proxy on the same origin.
 */
export const getApiBaseUrl = (): string => {
    const configured = process.env.REACT_APP_API_HOST ?? 'http://localhost:8080';

    if (typeof window === 'undefined') {
        return configured;
    }

    const isLocalPage =
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1';

    const configuredIsLocal = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/?$/i.test(configured);

    if (!isLocalPage && configuredIsLocal) {
        return window.location.origin;
    }

    return configured;
};
